module.exports = __webpack_public_path__ + "img/EXTERIOR-ERTIGA-BOOSTER-GREEN-1.3a26aa01.jpg";